import { useFeatureIsOn, useFeatureValue } from '@growthbook/growthbook-react';
import { Banner } from './ui/banner';
const IssueBanner = () => {
  const issueBannerIsOn = useFeatureIsOn('issue-banner');
  const issueBannerCopy = useFeatureValue('issue-banner-text', "We're working to resolve an issue with Uppbeat Credits & safelisting channels. Thanks for your patience.");
  const showIssueBanner = issueBannerIsOn;
  return <Banner condition={showIssueBanner} id="issue-banner" type="warning" useSessionStorageForDismiss variant="float-bottom" data-sentry-element="Banner" data-sentry-component="IssueBanner" data-sentry-source-file="IssueBanner.tsx">
      {issueBannerCopy}
    </Banner>;
};
export default IssueBanner;